import { render, staticRenderFns } from "./PresenceStatusDialog.vue?vue&type=template&id=7f88c0b5"
import script from "./PresenceStatusDialog.vue?vue&type=script&lang=js"
export * from "./PresenceStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports